
export const appStore = {
  namespaced: true,
  
  state: {
    isLoading: false, // TRẠNG THÁI LOADING TOÀN CỤC MỚI
  },
  
  mutations: {
    SET_LOADING(state, status) {
      state.isLoading = status;
    },
  },
  
  actions: {
    setLoading({ commit }, status) {
      commit('SET_LOADING', status);
    },
  },
  
  getters: {
    isLoading: (state) => state.isLoading,
  },
};